import Vuex from "vuex";
import Vue from "vue";
import axios from "axios";
import router from "../router";
Vue.use(Vuex);

// Import States
import sidebarState from "../store/sidebar/index.js";
// Import Mutations
import sidebarMutation from "../store/sidebar/mutations";

const state = {
  	...sidebarState,
  	token : null ,
  	userData : [],
   baseUrl : 'https://simpeg.bogorkab.go.id/srv/' 
   //baseUrl : 'http://203.148.84.83/srv/'
};

const mutations = {
  ...sidebarMutation,
   	setLoginState(state, payload) {
      state.token = payload.token;
      state.user = payload.data
    },
    removeUserAuth(state) {
      (state.user = {}), (state.token = null), (state.roles = []);
    }
};

const actions =  {

	    getData( context , data  ) {
            return new Promise((resolve, reject) => {
                let url = this.state.baseUrl + data.url 
                let config = {
                    headers: { 
                        'Accept': 'application/json',
                        'Authorization': 'Bearer '+ localStorage.getItem( 'token')
                    }
                };
                let rows = []
                axios.get( url,config ).then(response => {
                      resolve(response)   
                }).catch(error => {
                    console.log(error)  
                    router.push('/auth/login')
                                                            
                })
               
            })
        },
        postData( context , data  ) {
            return new Promise((resolve, reject) => {
                let url = this.state.baseUrl + data.url 
                let config = {
                    headers: { 
                        'Accept': 'application/json',
                        'Authorization': 'Bearer '+ localStorage.getItem('token')
                    }
                };
                let rows = []
                axios.post( url, data.params , config ).then(response => {
                      resolve(response)   
                }).catch(error => {
                     router.push('/auth/login')
                    reject(error)
                })
               
            })
        },
        deleteData( context , data  ) {
            return new Promise((resolve, reject) => {
                let url = this.state.baseUrl + data.url 
                let config = {
                    headers: { 
                        'Accept': 'application/json',
                        'Authorization': 'Bearer '+ localStorage.getItem('token')
                    }
                };
                let rows = [] 

                axios.post( url,  { _method: 'delete' } , config ).then(response => {
                      resolve(response)   
                }).catch(error => {
                    reject(error)
                })
               
            })
        }


}
const  getters =  {

}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});



// WEBPACK FOOTER //
// ./src/store/index.js